module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "custom-tb-stregth"
  }, [_c('tr', _vm._l((_vm.limitSubject()), function(item) {
    return _c('td', {
      staticClass: "text-center custom-td-strength"
    }, [_c('img', {
      staticClass: "img custom-img-strength",
      attrs: {
        "src": item.icon
      }
    }), _c('p', {
      staticClass: "txt-strength"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d7e180","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Strength.vue
// module id = 1530
// module chunks = 0